import { useEffect, useState } from "react"
import { userStore } from "../store/Store"
import { useNavigate } from "react-router-dom"

export default function useGetFetchFromId(url, setState, id, setOld, setOldField) {
  // global
  const JwtToken = userStore(data => data.JwtToken)

  //local
  const [theData, setTheData] = useState(null)
  const [isPending, setIsPending] = useState(true)
  const [error, setError] = useState(null)
  const [status, setStatus] = useState(null)
  const navigate = useNavigate()
  
  
  useEffect(() => {
    if (JwtToken === "") {
      navigate('/login')
      return
    }
    const controller = new AbortController()
    setIsPending(true)
    const headers = new Headers()
    headers.append("Content-Type", "application/json")
    headers.append("Authorization", "Bearer " + JwtToken)
    const ro = {
      method: "GET",
      headers,
      signal: controller.signal
    }
    
    if (id && id !== '' && id !== 0) {
      fetch(url, ro)
      .then((response) => {
        if (response.status === 401) {
          navigate('/login')
        }
        setStatus(response.status)
        return response.json()
      })
      .then(data => {
        if (setOldField && setOld) {
          setTheData(data)
          setOld(data[setOldField])
        }
        if (setState) {
          setState(data)
        }
        setIsPending(false)
      })
      .catch(err => {
        if (err.name === "AbortError") {
          console.log("The fetch was aborted")
          setIsPending(false)
          return
        } else {
          setIsPending(false)
          console.log(err)
          setError("Could not load the Data")
        }
      })
      return (() => {
        controller.abort()
      })
    } else {
      setIsPending(false)
    }
  }, [JwtToken, navigate, url, setState, id, setOld, setOldField])
  
  return {theData, isPending, error, status }
}
